// extracted by mini-css-extract-plugin
export var contrastLow = "_44-1";
export var externalLink = "_44-2";
export var externalLinkIcon = "_44-3";
export var link = "_44-0";
export var linkLabel = "_44-4";